// src/Public/onboarding-data.js

const ASSETS_URL = "https://sawpy-assets.s3.us-east-2.amazonaws.com/images/";

// 1. The Full Library
const ALL_ICONS = {
    LIGHTBULB: ASSETS_URL + "flowma_isometric_icon_filament_light_bulb.png",
    SCREEN_MODIFIED: ASSETS_URL + "flowma_isometric_icon_Modified_The_screen.png",
    SOCIAL_MEDIA: ASSETS_URL + "flowma_isometric_icon_most_famous_social_m.png",
    PINK_CART: ASSETS_URL + "flowma_isometric_icon_pink_shopping_cart.png",
    COMPASS: ASSETS_URL + "flowma_isometric_icon_Compass.png",
    SHOES_WALKING: ASSETS_URL + "flowma_isometric_icon_shoes_walking.png",
    FOLDER_3D: ASSETS_URL + "flowma_isometric_icon_3D_Folder_icon_with_.png",
    QUERY_BUILDER: ASSETS_URL + "flowma_isometric_icon_Query_Builder_A_slee.png",
    CHEETAH: ASSETS_URL + "flowma_isometric_icon_cheetah_running_on_a.png",
    MAN_WALKING: ASSETS_URL + "flowma_isometric_icon_a_man_walking_in_ams.png",
    AIRBNB_STYLE: ASSETS_URL + "flowma_isometric_icon_Airbnb_style_flat_ve.png",
    GLOWING_TRI: ASSETS_URL + "flowma_isometric_icon_abstract_glowing_tri.png",
    YOUNG_WOMAN: ASSETS_URL + "flowma_isometric_icon_A_young_woman_seen_f.png",
    WORLD_MAP: ASSETS_URL + "flowma_isometric_icon_a_worl_map_with_a_pe.png",
    WHATSAPP: ASSETS_URL + "flowma_isometric_icon_WhatsApp.png",
    SERVER: ASSETS_URL + "flowma_isometric_icon_server.png",
    HANDSHAKE_1: ASSETS_URL + "flowma_isometric_icon_handshake (1).png",
    ABSTRACT_CONSTRUCT: ASSETS_URL + "flowma_isometric_icon_two_abstract_constru.png",
    FUTURISTIC_SERVICE: ASSETS_URL + "flowma_isometric_icon_Futuristic_3D_servic.png",
    SECURE_DASHBOARD: ASSETS_URL + "flowma_isometric_icon_web_page,_secure_das.png",
    HANDSHAKE_MAIN: ASSETS_URL + "flowma_isometric_icon_Object__Handshake_Ma.png",
    FIGHT: ASSETS_URL + "flowma_isometric_icon_Jiu_jitsu_fight_betw.png",
    LAPTOP_SOCIAL: ASSETS_URL + "flowma_isometric_icon_Laptop,_social_media.png",
    MINI_FIGURE: ASSETS_URL + "flowma_isometric_icon_Isometric_mini_figur.png",
    ISO_REPR: ASSETS_URL + "flowma_isometric_icon_Isometric_icon_repre.png",
    ISO_CONCEPT: ASSETS_URL + "flowma_isometric_icon_Isometric_3D_concept.png",
    HANDSHAKE_SMALL: ASSETS_URL + "flowma_isometric_icon_handshake.png",
    HANDSHAKE_BUS: ASSETS_URL + "flowma_isometric_icon_hand_shaking_two_bus.png",
    FRONT_VIEW_OBJ: ASSETS_URL + "flowma_isometric_icon_Front_view,_single_c.png",
    BUSINESS_BUILDING: ASSETS_URL + "lowma_isometric_icon_business_building.png",
    CLOUD_PARTNER: ASSETS_URL + "flowma_isometric_icon_cloud_partner_consul.png",
    BUTTON_CONS: ASSETS_URL + "flowma_isometric_icon_button_with_two_cons.png",
    GOOGLE_BUSINESS: ASSETS_URL + "flowma_isometric_icon_busy_google_business.png",
    LICENSE: ASSETS_URL + "flowma_isometric_icon_business_license.png",
    LAPTOP_BLACK: ASSETS_URL + "flowma_isometric_icon_black_laptop_facing_.png",
    PALETTE: ASSETS_URL + "flowma_isometric_icon_art_palette_with_pai.png",
    RABBIT: ASSETS_URL + "flowma_isometric_icon_rabbit_running_fast_.png",
};

// 2. Active Mapping
const ACTIVE_ICONS = {
    NEW_PROJECT: ALL_ICONS.LIGHTBULB,
    UPGRADE: ALL_ICONS.LAPTOP_BLACK,
    LEADS: ALL_ICONS.HANDSHAKE_MAIN,
    ECOMMERCE: ALL_ICONS.PINK_CART,
    BRANDING: ALL_ICONS.COMPASS,
    ONE_PAGE: ALL_ICONS.MINI_FIGURE,
    FULL_SITE: ALL_ICONS.LAPTOP_BLACK,
    COMPLEX: ALL_ICONS.SERVER,
    CONTENT_READY: ALL_ICONS.FIGHT,
    CONTENT_PARTIAL: ALL_ICONS.FOLDER_3D,
    CONTENT_NONE: ALL_ICONS.AIRBNB_STYLE,
    FAST: ALL_ICONS.CHEETAH,
    STANDARD: ALL_ICONS.MAN_WALKING,
    SLOW: ALL_ICONS.YOUNG_WOMAN,
    HAS_LOGO: ALL_ICONS.LICENSE,      
    NO_LOGO: ALL_ICONS.PALETTE,
};

class OnBoardingData {
    constructor() {
        this.data = {
            en: {
                start: {
                    title: "Let's Define Your Project",
                    subtitle: "Answer a few questions to help us create a precise strategy for your business.",
                    cta: "Start Assessment"
                },
                loading: ["Analyzing requirements...", "Calculating scope...", "Finalizing proposal..."],
                success: {
                    title: "Request Received",
                    text: "Your project details have been recorded. Our team will review the specifications and contact you shortly.",
                    cta: "Back to Home"
                },
                steps: [
                    {
                        id: "status",
                        type: "select-single",
                        title: "Current Status",
                        options: [
                            { id: "new", label: "New Project", isCard: true, icon: ACTIVE_ICONS.NEW_PROJECT, description: "I need a brand new website built from scratch" },
                            { id: "redesign", label: "Upgrade / Redesign", isCard: true, icon: ACTIVE_ICONS.UPGRADE, description: "I have an existing site that needs improvement" }
                        ]
                    },
                    {
                        id: "objective",
                        type: "select-single",
                        title: "Primary Objective",
                        subtitle: "What is the most important outcome for this website?",
                        options: [
                            { id: "leads", label: "Lead Generation", isCard: true, icon: ACTIVE_ICONS.LEADS, description: "Focus on phone calls, messages, and contact forms" },
                            { id: "sales", label: "Online Sales", isCard: true, icon: ACTIVE_ICONS.ECOMMERCE, description: "Full E-commerce store for selling products" },
                            { id: "brand", label: "Brand Awareness", isCard: true, icon: ACTIVE_ICONS.BRANDING, description: "Showcase projects, information, and build trust" }
                        ]
                    },
                    {
                        id: "package",
                        type: "select-single",
                        title: "Project Scope",
                        subtitle: "Which structure best fits your content needs?",
                        options: [
                            { id: "landing", label: "Landing Page", isCard: true, icon: ACTIVE_ICONS.ONE_PAGE, description: "A single, focused page designed for conversion" },
                            { id: "full_site", label: "Corporate Website", isCard: true, icon: ACTIVE_ICONS.FULL_SITE, description: "Multi-page site (Home, About, Services, Contact)" },
                            { id: "complex", label: "Custom / Complex", isCard: true, icon: ACTIVE_ICONS.COMPLEX, description: "Requires custom development or special integrations" }
                        ]
                    },
                    {
                        id: "content",
                        type: "select-single",
                        title: "Content Readiness",
                        subtitle: "Do you have the materials (Logo, Text, Images) ready?",
                        options: [
                            { id: "ready", label: "Yes, everything is ready", isCard: true, icon: ACTIVE_ICONS.CONTENT_READY, description: "I have all assets organized" },
                            { id: "partial", label: "Partially ready", isCard: true, icon: ACTIVE_ICONS.CONTENT_PARTIAL, description: "I have some materials, but need help organizing" },
                            { id: "none", label: "No, starting from scratch", isCard: true, icon: ACTIVE_ICONS.CONTENT_NONE, description: "I need assistance with branding and copywriting" }
                        ]
                    },
                    {
                        id: "logo_status",
                        type: "select-single",
                        title: "Brand Logo",
                        subtitle: "Do you have a professional logo for your business?",
                        options: [
                            { id: "has_logo", label: "Yes, I have a logo", isCard: true, icon: ACTIVE_ICONS.HAS_LOGO, description: "I will upload my logo in the next step" },
                            { id: "no_logo", label: "No logo yet", isCard: true, icon: ACTIVE_ICONS.NO_LOGO, description: "I need help designing a new logo" }
                        ]
                    },
                    {
                        id: "timeline",
                        type: "select-single",
                        title: "Desired Timeline",
                        options: [
                            { id: "urgent", isCard: true, label: "As soon as possible", icon: ACTIVE_ICONS.FAST },
                            { id: "standard", isCard: true, label: "Standard (3-5 weeks)", icon: ACTIVE_ICONS.STANDARD },
                            { id: "flexible", isCard: true, label: "Flexible / No rush", icon: ACTIVE_ICONS.SLOW }
                        ]
                    },
                    {
                        id: "details",
                        type: "form",
                        title: "Final Details",
                        subtitle: "Where should we send the strategy proposal?",
                        fields: [
                            { name: "fullName", type: "text", label: "Full Name", placeholder: "Your Name", required: true },
                            { name: "phone", type: "phone", label: "Phone Number", placeholder: "Phone Number", required: true },
                            { name: "email", type: "email", label: "Email Address", placeholder: "Email Address", required: true },
                            { name: "logoFile", type: "file", label: "Upload Logo (Optional)", placeholder: "Choose file", required: false },
                            { name: "businessName", type: "text", label: "Business Name", placeholder: "Business Name", required: false },
                            { name: "website", type: "text", label: "Current Website (If exists)", placeholder: "www.example.com", required: false, dir: 'ltr' },
                            { name: "notes", type: "textarea", label: "Additional Notes", placeholder: "Any specific requirements...", required: false }
                        ]
                    }
                ]
            },
            he: {
                start: {
                    title: "אפיון פרויקט דיגיטלי",
                    subtitle: "ענה על מספר שאלות קצרות כדי שנוכל להתאים עבורך את האסטרטגיה המדויקת ביותר.",
                    cta: "התחל אפיון"
                },
                loading: ["מנתח את הנתונים...", "בונה פרופיל פרויקט...", "מכין את ההצעה..."],
                success: {
                    title: "הפרטים התקבלו בהצלחה",
                    text: "הבקשה נקלטה במערכת. צוות המומחים שלנו יעבור על הדרישות וייצור קשר בהקדם.",
                    cta: "חזרה לאתר"
                },
                steps: [
                    {
                        id: "status",
                        type: "select-single",
                        title: "מהי נקודת ההתחלה?",
                        options: [
                            { id: "new", label: "פרויקט חדש", isCard: true, icon: ACTIVE_ICONS.NEW_PROJECT, description: "הקמת אתר חדש מאפס" },
                            { id: "redesign", label: "שדרוג אתר קיים", isCard: true, icon: ACTIVE_ICONS.UPGRADE, description: "עיצוב מחדש, רענון או שיפור אתר פעיל" }
                        ]
                    },
                    {
                        id: "objective",
                        type: "select-single",
                        title: "מהי המטרה העיקרית?",
                        subtitle: "מהו המדד הכי חשוב להצלחת האתר?",
                        options: [
                            { id: "leads", label: "יצירת לידים (פניות)", isCard: true, icon: ACTIVE_ICONS.LEADS, description: "מיקוד בהשארת פרטים, טלפונים והודעות" },
                            { id: "sales", label: "מכירות אונליין", isCard: true, icon: ACTIVE_ICONS.ECOMMERCE, description: "חנות דיגיטלית מלאה למכירת מוצרים" },
                            { id: "brand", label: "חיזוק מותג ותדמית", isCard: true, icon: ACTIVE_ICONS.BRANDING, description: "אתר ייצוגי לבניית סמכות והצגת עבודות" }
                        ]
                    },
                    {
                        id: "package",
                        type: "select-single",
                        title: "היקף הפרויקט",
                        subtitle: "איזה מבנה אתר מתאים לצרכים הנוכחיים?",
                        options: [
                            { id: "landing", label: "דף נחיתה / עמוד אחד", isCard: true, icon: ACTIVE_ICONS.ONE_PAGE, description: "עמוד ממוקד שנועד להמרה מהירה" },
                            { id: "full_site", label: "אתר תדמית מלא", isCard: true, icon: ACTIVE_ICONS.FULL_SITE, description: "מבנה מרובה עמודים (בית, אודות, שירותים וכו')" },
                            { id: "complex", label: "מערכת מורכבת / Custom", isCard: true, icon: ACTIVE_ICONS.COMPLEX, description: "פיתוח מותאם אישית או אינטגרציות מיוחדות" }
                        ]
                    },
                    {
                        id: "content",
                        type: "select-single",
                        title: "מוכנות התוכן",
                        subtitle: "האם החומרים (לוגו, טקסטים, תמונות) מוכנים?",
                        options: [
                            { id: "ready", label: "כן, יש לי הכל מוכן", isCard: true, icon: ACTIVE_ICONS.CONTENT_READY, description: "החומרים מוכנים להזנה לאתר" },
                            { id: "partial", label: "חלקית", isCard: true, icon: ACTIVE_ICONS.CONTENT_PARTIAL, description: "יש בסיס, אך נדרש ליטוש וארגון" },
                            { id: "none", label: "לא, מתחילים מאפס", isCard: true, icon: ACTIVE_ICONS.CONTENT_NONE, description: "אצטרך עזרה במיתוג וכתיבת התוכן" }
                        ]
                    },
                    {
                        id: "logo_status",
                        type: "select-single",
                        title: "לוגו ומיתוג",
                        subtitle: "האם יש לעסק לוגו מקצועי מוכן?",
                        options: [
                            { id: "has_logo", label: "כן, יש לי לוגו", isCard: true, icon: ACTIVE_ICONS.HAS_LOGO, description: "אצרף את הקובץ בשלב הבא" },
                            { id: "no_logo", label: "עדיין אין לי לוגו", isCard: true, icon: ACTIVE_ICONS.NO_LOGO, description: "אצטרך עזרה בעיצוב לוגו חדש" }
                        ]
                    },
                    {
                        id: "timeline",
                        type: "select-single",
                        title: "לוחות זמנים",
                        options: [
                            { id: "urgent", isCard: true, label: "בהקדם האפשרי (דחוף)", icon: ACTIVE_ICONS.FAST },
                            { id: "standard", isCard: true, label: "סטנדרטי (3-5 שבועות)", icon: ACTIVE_ICONS.STANDARD },
                            { id: "flexible", isCard: true, label: "גמיש", icon: ACTIVE_ICONS.SLOW }
                        ]
                    },
                    {
                        id: "details",
                        type: "form",
                        title: "פרטי התקשרות",
                        subtitle: "לאן לשלוח את סיכום האפיון?",
                        fields: [
                            { name: "fullName", type: "text", label: "שם מלא", placeholder: "שם מלא", required: true },
                            { name: "phone", type: "phone", label: "טלפון נייד", placeholder: "מספר טלפון", required: true },
                            { name: "email", type: "email", label: "כתובת אימייל", placeholder: "כתובת אימייל", required: true },
                            { name: "logoFile", type: "file", label: "צרף לוגו (אופציונלי)", placeholder: "בחר קובץ", required: false },
                            { name: "businessName", type: "text", label: "שם העסק", placeholder: "שם העסק (אופציונלי)", required: false },
                            { name: "website", type: "text", label: "כתובת אתר נוכחי (במידה ויש)", placeholder: "www.example.com", required: false, dir: 'ltr' },
                            { name: "notes", type: "textarea", label: "הערות נוספות", placeholder: "דגשים מיוחדים שחשוב שנדע...", required: false }
                        ]
                    }
                ]
            }
        };
    }

    getByLanguage(lang) {
        return this.data[lang] || this.data['en'];
    }
}

export default new OnBoardingData();